import React from 'react';
import { Box, Grid, Card, CardContent, Typography } from '@material-ui/core';
import { Title } from 'app/components';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import moment from 'moment';

import {
  RegtankInfoTable,
  RegtankLivenessDownloadTable,
  RegtankDownloadTable,
  RegtankRiskTable,
} from '../index';

const useStyles = makeStyles((theme) => ({
  container: {
    '@media print': {
      display: 'block',
    },
  },

  fullWidthOnPrint: {
    '@media print': {
      width: '100% !important',
      maxWidth: '100% !important',
      flexBasis: '100% !important',
    },
  },

  printSection: {
    marginBottom: theme.spacing(2),
    pageBreakInside: 'avoid',
    breakInside: 'avoid',
  },

  noPrint: {
    '@media print': {
      display: 'none',
    },
  },

  frame: {
    width: '80%',
    margin: 'auto',
  },

  logo: {
    height: 60,
  },

  headerSpacing: {
    marginBottom: theme.spacing(2),
  },
}));

const DownloadDocumentPreview = ({
  cancelPrint,
  document,
  summary,
  info,
  risk,
  kyc,
  liveness,
  documents,
}) => {

  const classes = useStyles();

  const getButtons = () => [
    { space: 3, onClick: cancelPrint, text: 'Cancel' },
    { space: 4, onClick: () => window.print(), text: 'Download PDF' },
  ];

  return (
    <Box>

      {/* Hide buttons in PDF */}
      <div className={classes.noPrint}>
        <Title prefix="Print preview" floatButtons={getButtons()} />
      </div>

      {/* 🔥 WRAP EVERYTHING IN ONE PRINT FRAME */}
      <Card className={clsx(classes.frame)}>

        <CardContent>

          {/* 🔥 HEADER (NEW) */}
          <div className={classes.printSection}>

            <Grid container justify="space-between">
              <Grid item>
                <img
                  alt="Brand"
                  className={classes.logo}
                  src="/images/traxx_logo.svg"
                />
              </Grid>
            </Grid>

            <Grid container className={classes.headerSpacing}>
              <Grid item>
                <Typography variant="h4">
                  Screening Report
                </Typography>
              </Grid>
            </Grid>

            <Grid container className={classes.headerSpacing}>
              <Grid item>
                <Typography variant="body2">
                  {`Report generated on ${moment().format('DD MMM YYYY, HH:mm')}`}
                </Typography>
              </Grid>
            </Grid>

          </div>

          {/* 🔥 MAIN CONTENT */}
          <Grid container spacing={2} className={classes.container}>

            {/* LEFT */}
            <Grid item lg={6} sm={12} className={classes.fullWidthOnPrint}>

              <Card className={classes.printSection} style={{ padding: 16 }}>
                <div><b>Document ID:</b> {summary?.documentId || document?.reference}</div>
                <div><b>Type:</b> {summary?.type || document?.type}</div>
                <div><b>Status:</b> {summary?.status}</div>
              </Card>

              <div className={classes.printSection}>
                <RegtankInfoTable info={info || {}} />
              </div>

              <div className={classes.printSection}>
                <RegtankLivenessDownloadTable liveness={liveness || {}} />
              </div>

              <div className={classes.printSection}>
                <RegtankDownloadTable documents={documents || {}} />
              </div>

            </Grid>

            {/* RIGHT */}
            <Grid item lg={6} sm={12} className={classes.fullWidthOnPrint}>
              <div className={classes.printSection}>
                <RegtankRiskTable kyc={kyc || {}} risk={risk || {}} />
              </div>
            </Grid>

          </Grid>

        </CardContent>
      </Card>
    </Box>
  );
};

export default DownloadDocumentPreview;